import { ExportOutlined } from "@ant-design/icons";
import { Button } from "@pankod/refine-antd";
import { exportData } from "apis/export";
import React, { useCallback, useState } from "react";

export interface ButtonProps {
  path: string;
}

export const ButtonExport: React.FC<ButtonProps> = ({ path }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const handleData = useCallback(async (path: string) => {
    setLoading(true);
    await exportData(path);
    setLoading(false);
  }, []);
  return (
    <Button onClick={() => handleData(path)} loading={loading}>
      {!loading && <ExportOutlined />}
      Export
    </Button>
  );
};
